"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HiroApi = void 0;
const tools_1 = require("../../utils/tools");
class HiroApi {
    constructor({ token }) {
        let apiKey = token;
        const baseUrl = "https://api.mainnet.hiro.so/";
        this.api = (0, tools_1.getAxiosInstance)({
            baseUrl,
            headers: {
                "x-hiro-api-key": apiKey,
            },
        });
    }
    getInscription(inscriptionId) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let inscription = (_a = (yield this.api.get(`/ordinals/v1/inscriptions/${inscriptionId}`))) === null || _a === void 0 ? void 0 : _a.data;
                return inscription;
            }
            catch (err) {
                return null;
            }
        });
    }
    getInscriptionsForAddress(address, { limit = 50, offset = 0 }) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            let inscriptions = ((_b = (_a = (yield this.api.get(`/ordinals/v1/inscriptions`, {
                params: {
                    limit,
                    offset,
                    order: "desc",
                    order_by: "genesis_block_height",
                    address,
                },
            }))) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.results) || [];
            return inscriptions;
        });
    }
    getInscriptionsForAddressWithRetry(address, { limit = 50, offset = 0 }) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, tools_1.runWithRetries)(() => this.getInscriptionsForAddress(address, { limit, offset }), {
                maxTries: 3,
                retrySleep: 3000,
            });
        });
    }
    getAllInscriptionsForAddress(address) {
        return __awaiter(this, void 0, void 0, function* () {
            let limit = 50;
            let offset = 0;
            let inscriptions = [];
            let result;
            do {
                result = yield this.getInscriptionsForAddressWithRetry(address, { limit, offset });
                inscriptions.push(...result);
                offset += limit;
            } while (result.length === offset);
            return inscriptions;
        });
    }
    getInscriptionWithRetry(inscriptionId) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, tools_1.runWithRetries)(() => this.getInscription(inscriptionId), {
                maxTries: 3,
                retrySleep: 3000,
            });
        });
    }
    static convertByIdToInscription(inscription) {
        return {
            owner: inscription.address,
            inscriptionId: inscription.id,
            inscriptionNumber: BigInt(+inscription.number),
            inscriptionTitle: `Inscription ${inscription.number}`,
            contentURI: `https://ordinals.com/content/${inscription.id}`,
            contentType: inscription.content_type,
            contentLength: inscription.content_length + "",
            genesisHeight: +inscription.genesis_block_height,
            genesisTransaction: inscription.genesis_tx_id,
            genesisFee: +inscription.genesis_fee,
            outputLocation: inscription.location,
            satNumber: BigInt(inscription.sat_ordinal),
            satRarity: inscription.sat_rarity,
            satCoinbaseHeight: inscription.sat_coinbase_height,
        };
    }
}
exports.HiroApi = HiroApi;
//# sourceMappingURL=hiro.api.js.map